module.exports = require("/codebuild/output/src3135075441/src/phx-global-form-gatsby/src/gatsby/gatsby-browser.ts");